import { Container, Row, Col } from "react-bootstrap";
import { ChangelogItem } from "../components/changelog/ChangelogItem";
import { changelog } from "../constants/changelog";

const styles = {
  title: {
    color: "rgb(70, 130, 180)",
    marginBottom: "16px",
    marginTop: "32px"
  }
};

function Changelog() {
  return (
    <Container>
      <Row>
        <h3 style={styles.title}>Changelog</h3>
        <Col>
          {changelog.map((e, index) => {
            return (
              <ChangelogItem
                title={e.title}
                changes={e.changes}
                key={`${e.title.replaceAll(" ", "-")}-${index}`}
              />
            );
          })}
        </Col>
      </Row>
    </Container>
  );
}

export default Changelog;
